import React from 'react';
import { useForm } from 'react-hook-form';
import { replaceDefaultValues } from '../../helpers/form';
import FormElement from '../core/FormElement';
import StepFormSubStepButtons from '../StepForm/StepFormSubStepButtons';

interface Props {
  onSubmit: (data: { [x: string]: any }) => void;
  onBackClick: () => void;
  types?: string[];
  defaultValues?: any;
}

export default function Form1(props: Props) {
  const { register, handleSubmit, errors, control } = useForm({
    defaultValues: replaceDefaultValues(
      {
        infoType: '',
        infoEstrato: 3,
        description: '',
        pricesProperty: '',
      },
      props.defaultValues
    ),
  });

  return (
    <form onSubmit={handleSubmit(props.onSubmit)}>
      <h1>¿Qué tipo de propiedad tienes?</h1>

      <FormElement
        name="infoType"
        label="Tipo de propiedad*"
        placeholder="Apartamento, casa..."
        inputRef={register({ required: true })}
        error={errors.infoType}
        elementType="select"
        options={(props.types ?? []).map((el) => ({ name: el, value: el }))}
      />

      <FormElement
        name="description"
        label="Describe la propiedad*"
        placeholder="Descripción"
        inputRef={register({ required: true })}
        error={errors.description}
        elementType="textarea"
        variant="outlined"
      />

      <FormElement
        control={control}
        name="infoEstrato"
        label="Estrato"
        elementType="numberButtons"
        min={1}
        max={6}
      />

      <StepFormSubStepButtons onBackClick={props.onBackClick} />
    </form>
  );
}
